export const scrollToId = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -80, duration: 1.3 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
